import React from 'react';
import { nycImage, nyc2Image, companies } from '../mock';
import { Building2, TrendingUp, LandPlot } from 'lucide-react';

export default function InvestmentsSection() {
  return (
    <section id="investments" className="section" style={{ background: 'var(--sm-navy)', color: 'var(--sm-ivory)', position: 'relative', overflow: 'hidden' }}>
      <div className="container-x">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 96, alignItems: 'start' }} className="inv-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
              <span style={{ height: 1, width: 56, background: 'var(--sm-gold)', display: 'inline-block' }} />
              <span className="overline" style={{ color: 'var(--sm-gold-soft)' }}>Real Estate Investments</span>
            </div>
            <h2 className="serif" style={{ fontSize: 'clamp(36px, 4.5vw, 58px)', lineHeight: 1.08, letterSpacing: '-0.015em', margin: 0 }}>
              Diversifying into long-term productive assets.
            </h2>
            <p style={{ marginTop: 28, fontSize: 16.5, lineHeight: 1.85, color: 'rgba(246,241,230,0.75)', textAlign: 'justify' }}>
              Beyond distribution, ES Investments Management LLC is a committed real estate investor. Building on two decades of disciplined trade, the company deploys capital into long-horizon property assets, prioritizing quality locations, resilient cash flows, and patient value creation.
            </p>

            <div style={{ marginTop: 48, display: 'grid', gap: 16 }}>
              {[
                { icon: Building2, title: 'Commercial Properties', desc: 'Office and retail assets in established metropolitan markets.' },
                { icon: LandPlot, title: 'Development & Value-Add', desc: 'Selective repositioning of properties with strong underlying fundamentals.' },
                { icon: TrendingUp, title: 'Long-Term Holdings', desc: 'A patient-capital approach focused on durable, income-producing assets.' },
              ].map(({ icon: Icon, title, desc }) => (
                <div key={title} style={{ display: 'flex', gap: 20, padding: '20px 0', borderTop: '1px solid rgba(246,241,230,0.12)' }}>
                  <div style={{ flexShrink: 0, marginTop: 4 }}>
                    <Icon size={22} color="var(--sm-gold-soft)" strokeWidth={1.2} />
                  </div>
                  <div>
                    <div className="serif" style={{ fontSize: 20, marginBottom: 4 }}>{title}</div>
                    <div style={{ fontSize: 14, lineHeight: 1.65, color: 'rgba(246,241,230,0.6)' }}>{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: 'relative' }}>
            <div style={{ aspectRatio: '4/5', overflow: 'hidden' }}>
              <img src={nycImage} alt="New York City" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ position: 'absolute', bottom: -40, left: -40, width: '55%', aspectRatio: '1/1', overflow: 'hidden', border: '6px solid var(--sm-navy)', display: 'none' }} className="inv-inset">
              <img src={nyc2Image} alt="NYC skyline" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ position: 'absolute', top: 24, right: 24, background: 'var(--sm-ivory)', color: 'var(--sm-navy)', padding: '18px 22px' }}>
              <div className="serif" style={{ fontSize: 28 }}>NYC</div>
              <div style={{ fontSize: 10, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-muted)', marginTop: 4 }}>Home Base</div>
            </div>
          </div>
        </div>

        {/* Companies */}
        <div style={{ marginTop: 128 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 40 }}>
            <span style={{ height: 1, width: 56, background: 'var(--sm-gold)', display: 'inline-block' }} />
            <span className="overline" style={{ color: 'var(--sm-gold-soft)' }}>Business Divisions</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }} className="co-grid">
            {companies.map((c, i) => (
              <div key={c.name} style={{ padding: 32, background: 'rgba(246,241,230,0.04)', border: '1px solid rgba(246,241,230,0.12)' }}>
                <div style={{ fontSize: 11, letterSpacing: '0.28em', color: 'var(--sm-gold-soft)' }}>0{i + 1} · {c.role}</div>
                <div className="serif" style={{ fontSize: 26, marginTop: 14, marginBottom: 14 }}>{c.name}</div>
                <p style={{ fontSize: 14, lineHeight: 1.75, color: 'rgba(246,241,230,0.65)', margin: 0 }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .inv-grid, .co-grid { grid-template-columns: 1fr !important; gap: 56px !important; }
        }
      `}</style>
    </section>
  );
}
